import Vue from "vue";
import Vuex from "vuex";
import { getAPI } from "./axios-api";
import router from "./router";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    accessToken: localStorage.getItem("access") || "",
    status: "",
  },
  mutations: {
    updateStorage(state, { access }) {
      state.accessToken = access;
    },
    destroyToken(state) {
      state.accessToken = null;
    },
  },
  getters: {
    isAuthenticated: (state) => !!state.accessToken,
    authStatus: (state) => state.status,
    loggedIn(state) {
      return state.accessToken != null;
    },
  },
  actions: {
    userLogin(context, usercredentials) {
      return new Promise((resolve, reject) => {
        getAPI
          .post("/login/", {
            username: usercredentials.username,
            password: usercredentials.password,
            balai: usercredentials.balai,
          })
          .then((response) => {
            localStorage.setItem("access", response.data.token);
            localStorage.setItem("user-info", JSON.stringify(response.data));
            localStorage.setItem("role", JSON.stringify(response.data.profile.role));
            context.commit("updateStorage", { access: response.data.token });
            resolve();
          })
          .catch((err) => {
            localStorage.removeItem("access");
            reject(err);
          });
      });
    },
    userLogout(context) {
      context.commit("destroyToken");
      localStorage.removeItem("access");
      localStorage.removeItem("user-info");
      localStorage.removeItem("role");
      router.push({ name: "Login" });
      location.reload();
    },
  },
});
